import { dissoc } from 'ramda';
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

const initialState = {
	tasks: {},
};

export const tasksReducer = handleActions(
	{
		[types.SET_TASKS]: (state, { payload }) => {
			const newState = {};

			payload.tasks.forEach((task) => {
				newState[task.id] = task;
			});

			return newState;
		},
		[types.REMOVE_TASKS]: (state, { payload }) => dissoc(payload.id, state),
		[types.RESET_TASKS]: () => initialState.tasks,
	},
	initialState.tasks,
);

export default combineReducers({
	tasks: tasksReducer,
});
